import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor(
    private http: HttpClient
  ) { }

  logScreenHit(screenName: string) : Observable<any> {
    let body = {
      page_name: screenName
    }

    const url = environment.PRESSROOM_API_URL + 'screenhits/log';

    return this.http.post(url, body).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  logError(errorDescription: string) : Observable<any> {
    let body = {
      error_description: errorDescription
    }

    const url = environment.PRESSROOM_API_URL + 'logging/clientError';

    return this.http.post(url, body).pipe(
      map((data: any) => {
        return data;
      })
    );
  }
}
